import 'dls-fonts/dist/styles/banco-do-brasil.min.css';
import { getConfig, FALLBACK_STATUS } from './config';
import { setupSidebarOptionsFromStrapi } from './utils/sidebar';
import pkg from '../package.json';
import { setupHeaderOptions } from './utils/header';

if (window.apw.APW_ROOT_PAGE_TITLE) {
  document.title = window.apw.APW_ROOT_PAGE_TITLE;
}

const processName = keyName =>
  keyName
    .split('_')
    .map((value, index) =>
      index
        ? value
            .split('')
            .map((letter, lIdx) => (lIdx ? letter.toLowerCase() : letter.toUpperCase()))
            .join('')
        : value.toLowerCase(),
    )
    .join('');

const resolveBundleUrl = value => {
  const baseUrl = window.location.origin;

  if (value === '') {
    return `${baseUrl}/appms/bundle.js`;
  }

  if (value.startsWith('http')) {
    return value;
  }

  return `${baseUrl}${value}`;
};

getConfig()
  .then(async apwConfig => {
    const { apw } = window;
    const regIsSubConfig = new RegExp(/APW_.*_OPTIONS/);
    const regIsRootConfig = new RegExp(/^APW_((?!_OPTIONS).)*$/);

    apw.VERSION = pkg.version;

    for (const key in apwConfig) {
      if (regIsRootConfig.test(key)) {
        const value = apwConfig[key];
        const isBundleUrl = key === 'APW_BUNDLE_APP_URL';
        apw[key] = isBundleUrl ? resolveBundleUrl(value) : value;
      } else if (regIsSubConfig.test(key)) {
        const config = apwConfig[key];
        const keyName = processName(key);
        window[keyName] = !config.apwHeaderItemsURL ? Object.freeze(config) : config;
      }
    }

    await setupHeaderOptions(apwConfig);
    await setupSidebarOptionsFromStrapi(apwConfig);
    window.apw = Object.freeze(apw);
  })
  .catch(err => {
    const isProd = window.apw?.APW_ENV === 'prod' || window.apw?.APW_ENV === 'prd';
    if (FALLBACK_STATUS.includes(err.status)) {
      window.apwConfigLoadError = 404;
    } else if (!isProd) {
      window.apwConfigLoadError = 501;
    } else {
      window.apwConfigLoadError = undefined;
    }
  })
  .finally(() => {
    import('./bootstrap');
  });
